import React from 'react';
import { useDispatch } from 'react-redux';
import { listerClickThrough } from '../../../actions/lister-actions';
import TRANSLATIONS from './translations@default.json';

const ReviewsLayout = ({
	Rating,
	RatingValue,
	ReviewCount,
	FullProductUrl,
	Code,
	classes,
}) => {
	const dispatch = useDispatch();

	return (
		<div
			className={`${classes} product-card__rating text-sm`}
			data-testid="large-reviews-layout">
			<a
				href={`${FullProductUrl}#reviewsSection`}
				aria-label={`${RatingValue} out of 5 stars, ${ReviewCount} reviews`}
				onClick={(event) => {
					event.preventDefault();
					window.location.assign(`${FullProductUrl}#reviewsSection`);

					dispatch(listerClickThrough(Code));
				}}
				className="inline-flex flex-wrap items-center text-cta-action font-regular"
				data-testid="product-card-link">
				<span
					className={`rating-${Rating} product-card__rating-stars mt-1 mr-1 md:text-base md:leading-none`}
				/>

				<span className="mt-1 text-link text-body-xs z-10 whitespace-no-wrap">
					<span className="product-card__rating-value mr-1">
						{`${RatingValue} / 5`}
					</span>

					<span className="product-card__rating-count">
						(
						<span>
							{ReviewCount} {TRANSLATIONS.reviews.amountOfReviews}
						</span>
						)
					</span>
				</span>
			</a>
		</div>
	);
};

const ReviewRating = (props) => {
	const { Rating, RatingValue, ReviewCount } = props;

	if (Rating && ReviewCount && RatingValue && RatingValue > 0) {
		return <ReviewsLayout {...props} />;
	}

	return null;
};

export default ReviewRating;
